import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

export type ContactPageFaqCard = {
  description: ReactNode | ReactNode[]
  href: string
  onClick?: () => void
  title: string
}

export const ContactPageFaqCardsSectionCard: FC<ContactPageFaqCard> = ({
  description,
  href,
  onClick,
  title,
}) => {
  return (
    <div className="relative flex w-full flex-col justify-between rounded-m bg-light-brand-medium p-4 hover:bg-light-brand-low hover:shadow-m">
      <div className="text-left">
        <p className="text-l font-medium">{title}</p>
        <p className="my-4 line-clamp-4 text-m">{description}</p>
      </div>
      <Button<'a'>
        className="w-full items-end justify-between after:absolute after:inset-0 tablet:mt-4"
        endIcon={<IconArrowRight className="text-dark-hover-brand" />}
        href={href}
        onClick={onClick}
        size="large"
        slots={{ root: 'a' }}
        variant="text"
      >
        <FormattedMessage id="contact.faqCardsSection.card.cta.label" />
      </Button>
    </div>
  )
}
